/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: qjs
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: qjs
 * @LastEditTime: 2020-05-19 13:14:45
 */

import Vue from '../src/components/timeDate/timeDate'

Vue.directive('roleBtn',{
    inserted:function (el,binding) {
      if(localStorage.getItem('btnKeys')){
        let roleArr = binding.value;
        let temp=localStorage.getItem('btnKeys').split(",")
        let userRole =  temp
        if (roleArr[0].toString() && userRole.indexOf(roleArr[0].toString()) !== -1) {
          return false
        } else {
          el.parentNode.removeChild(el);
        }
      }
  },
})
export default Vue






// WEBPACK FOOTER //
// ./src/btnPermission.js